/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 15.05.2015
 *   Time: 12:36
 */

/**
 * @private
 */
export class TimeUtils {
    /**
     * Calculates time zone offset for the system locale
     * @return Time zone offset in milliseconds.
     */
    public static getTimezoneOffset(): number {
        // Create two dates: one summer and one winter
        let d1: Date = new Date(0, 0, 1);
        let d2: Date = new Date(0, 6, 1);

        // largest value has no DST modifier
        let tzd: number = Math.max(d1.getTimezoneOffset(), d2.getTimezoneOffset());

        // convert to milliseconds
        return -tzd * 60000;
    }

    public static getDST(d: Date): number {
        let tzd: number = TimeUtils.getTimezoneOffset();
        let dst: number = d.getTimezoneOffset() * 60000 - tzd;
        return dst;
    }

    public static unixToHumanTime(timeStamp: number): string {
        // unix timestamp -> human date
        // timestamp_in_seconds*1000 - if you use a result of PHP time function, which returns it in seconds, and Flash uses milliseconds
        let currDate: Date = new Date(timeStamp * 1000);

        let hour: number = currDate.getHours();
        let minute: number = currDate.getMinutes();
        let day: number = currDate.getDate();
        let month: number = currDate.getMonth() + 1; // +1 because Returns the month (0 for January, 1 for February, and so on)

        let theDate: string = hour + ":" + minute + "-" + day + "/" + month;

        return theDate;
    }
}
